module.exports = __webpack_public_path__ + "img/folder-file.ee2dc555.svg";